import React from 'react';
import { format, parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import { makeStyles, TablePagination } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

const createRows = (data) => {
  const rows = [];
  for (let i = 0; i < data.length; i++) {
    const row = {
      id: data[i]?.id || '',
      created_at: data[i]?.created_at || '',

      tcn_customer_id: data[i]?.tcn_customer_id || '',
      customer_name: data[i]?.customer_name || '',

      customer_email: data[i]?.customer_email || '',
      email: data[i]?.email || '',

      notification_email: data[i]?.notification_email || '',

      request_amount: data[i]?.request_amount || '',

      user_id: data[i]?.user_id || '',
      user_email: data[i]?.user.email || '',
      user_first_name: data[i]?.user.first_name,
      user_last_name: data[i]?.user.last_name || '',
      user_type: data[i]?.user_type || '',

      response_body: data[i]?.response_body ? JSON.stringify(JSON.parse(data[i]?.response_body), null, 4) : ''
    };

    rows.push(row);
  }
  return rows;
};

const LogsBody = ({
  logs,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  totalRowCount,
  page
}) => {
  const classes = useStyles();
  const rows = logs.length > 0 ? createRows(logs) : [];

  return (
    <>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer component={Paper} className="table-container">
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Id </TableCell>
                <TableCell align="left">Created At</TableCell>
                <TableCell align="left">Customer</TableCell>
                <TableCell align="left">Email 1</TableCell>
                <TableCell align="left">Email 2</TableCell>
                <TableCell align="left">Notification Email</TableCell>
                <TableCell align="left">Request Amount</TableCell>
                <TableCell align="left">Request User</TableCell>
                <TableCell align="left">Webservice Response</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length > 0 ? (
                rows.map((row, i) => (
                  <TableRow key={i}>
                    <TableCell align="left">{row.id}</TableCell>
                    <TableCell align="left">{row.created_at ? format(parseISO(row.created_at), 'yyyy-MM-dd HH:mm:ss') : '-'}</TableCell>
                    <TableCell align="left">{row.tcn_customer_id} - {row.customer_name}</TableCell>
                    <TableCell align="left">{row.customer_email}</TableCell>
                    <TableCell align="left">{row.email}</TableCell>
                    <TableCell align="left">{row.notification_email}</TableCell>
                    <TableCell align="left">{row.request_amount}</TableCell>
                    <TableCell align="left">{row.user_email} - {row.user_id}</TableCell>
                    <TableCell align="left"><pre style={{ maxHeight: 100, overflowY: 'scroll' }}>{row.response_body}</pre></TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow style={{ height: 53 * 1 }}>
                  <TableCell colSpan={6}>
                    {' '}
                    No data available in table{' '}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={totalRowCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
};

LogsBody.propTypes = {
  logs: PropTypes.array,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  totalRowCount: PropTypes.number,
};

export default LogsBody;
